import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EdsContentComponent } from './eds-content/eds-content.component';
import { LoginBySmsAuthorizeComponent } from './login-by-sms/login-by-sms-authorize/login-by-sms-authorize.component';
import { LoginBySmsFormComponent } from './login-by-sms/login-by-sms-form/login-by-sms-form.component';
import { SharedModule } from '../../../shared/shared.module';

const components = [
  EdsContentComponent,
  LoginBySmsFormComponent,
  LoginBySmsAuthorizeComponent,
];

@NgModule({
  imports: [FormsModule, SharedModule, ReactiveFormsModule],
  exports: [...components],
  declarations: [...components],
  providers: [],
})
export class LandingSharedModule {
}
